import { Typography } from "@braintrust/braintrust-ui-components";
import { DoneAllIcon } from "@braintrust/braintrust-ui-components/Icons";
import { Modal } from "@js/components/modal";

import styles from "./style.module.scss";

const CC_PAYMENT_SUCCESS_MODAL_ID = "cc-payment-success-modal";
const PAYMENT_SUCCESS_MODAL_ID = "payment-success-modal";

export const CCPaymentSuccessModalInstance = Modal(CC_PAYMENT_SUCCESS_MODAL_ID);
export const PaymentSuccessModalInstance = Modal(PAYMENT_SUCCESS_MODAL_ID);

const CCPaymentMethodSuccessModalContent = () => {
  return (
    <div className={styles.paymentSuccessModal}>
      <DoneAllIcon className={styles.paymentSuccessModalIcon} />
      <Typography component="p" size="large">
        Payment successful!
      </Typography>
      <Typography component="p">Thank you.</Typography>
    </div>
  );
};

const PaymentSuccessModalContent = () => {
  return (
    <div className={styles.paymentSuccessModal}>
      <DoneAllIcon className={styles.paymentSuccessModalIcon} />
      <Typography component="p" size="large">
        Thank you. Your payment is being processed right now. You'll be notified
        with the status of it.
      </Typography>
    </div>
  );
};

export const openPaymentSuccessModal = ({
  onClose,
}: {
  onClose?: () => void;
}) => {
  PaymentSuccessModalInstance.open({
    children: <PaymentSuccessModalContent />,
    onClose,
  });
};

export const openCCPaymentMethodSuccessModal = ({
  onClose,
}: {
  onClose?: () => void;
}) => {
  CCPaymentSuccessModalInstance.open({
    children: <CCPaymentMethodSuccessModalContent />,
    onClose,
  });
};
